import { Col, Row } from "antd";
import styles from "../Layout.module.scss";
import { featureData, features } from "../../Categories/data";

export const PreFooter = (props) => {
  return (
    <>
      {!props.hidePreFooter && (
        <section className={`${styles.features} dt_only container`}>
          <Row gutter={[20, 20]}>
            {features.map((feature, index) => (
              <Col lg={6} key={index}>
                <div className={styles.features_item}>
                  <img src={feature.image} alt="feature_image" loading="lazy" />
                  <h3>{feature.title}</h3>
                </div>
              </Col>
            ))}
          </Row>
        </section>
      )}
      {/*Ad - Desktop Only*/}
      {!props.hidePreFooter && (
        <section className={`${styles.ad} dt_only`}>
          <img
            src="https://desi-fresh.b-cdn.net/misc/Small%20Banner.png"
            alt="discount"
            loading="lazy"
          />
        </section>
      )}
      {/* 5 card - desktop only */}
      {!props.hidePreFooter && (
        <section className={`${styles.feature_second} container dt_only`}>
          <Row gutter={[20, 20]}>
            {featureData.map((feature, index) => (
              <Col flex={1} key={index}>
                <div className={styles.features_item}>
                  <img src={feature.image} alt="feature_image" loading="lazy" />
                  <h3>{feature.title}</h3>
                </div>
              </Col>
            ))}
          </Row>
        </section>
      )}
    </>
  );
};
